import { render } from "./GSelect.vue?vue&type=template&id=7d3af615"
import script from "./GSelect.vue?vue&type=script&lang=js"
export * from "./GSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__